declare var wenji: any;

// Core modules
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

//Services
import { SynchronymeService } from "./service/synchronyme/synchronyme.service";

@Component({
    selector: 'synchronyme-app',
    templateUrl: 'synchronyme.html'
})
export class SynchronymeComponent implements OnInit {
    public synchronymeData: any;

    private routeParams: any = {};

    constructor(
        private synchronymeService: SynchronymeService,
        private router: Router,
        private route: ActivatedRoute,
    ) {
        this.synchronymeData = this.synchronymeService.data;
    }

    public getRouteParams(): void {
        this.routeParams = this.route.params.subscribe((params: any) => {
            //store params in routeParams
             this.synchronymeData.urlParams = params;
        });
    }

    /*
     * setAppName
     * store AppName in session storage for Header
     */
    public setAppName(): void {
        document.title = wenji.synchronyme.name;
        sessionStorage.setItem('childAppName', wenji.synchronyme.name);
    }

    public ngOnInit(): void {
        this.setAppName();
        this.getRouteParams();
    }
}
